import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import {
  ProjectJourneyHistory,
  ProjectJourneySnapshot,
  ReprocessRecognitionRequest,
  ReprocessRecognitionResult,
} from '@lite-workspace/dto-fotoclass-common';

@Injectable({ providedIn: 'root' })
export class ProjectJourneyApi {
  private readonly http = inject(HttpClient);

  async getSnapshot(projectId: string): Promise<ProjectJourneySnapshot> {
    return firstValueFrom(this.http.get<ProjectJourneySnapshot>(`/api/project-journey/${projectId}/snapshot`));
  }

  async getHistory(projectId: string, limit?: number): Promise<ProjectJourneyHistory> {
    const params = limit ? { limit: String(limit) } : undefined;
    return firstValueFrom(this.http.get<ProjectJourneyHistory>(`/api/project-journey/${projectId}/history`, { params }));
  }

  /** dryRun считает то же самое и ничего не пишет — первый шаг любого прогона. */
  async reprocessRecognition(projectId: string, request: ReprocessRecognitionRequest): Promise<ReprocessRecognitionResult> {
    return firstValueFrom(
      this.http.post<ReprocessRecognitionResult>(
        `/api/fotoklass-main-process/projects/${projectId}/reprocess-recognition`,
        request,
      ),
    );
  }
}
